export default "__VITE_ASSET__CRgoyk5X__"